import React from "react";
import "./PrivacyPolicyAppArabic.css";

const PrivacyPolicyAppArabic = () => {
  return (
    <div className="privacy-policy" style={{background:'white'}}>
      <h1 className="main-title">سياسة الخصوصية لتطبيق MUSARO</h1>
      <p>
        توضح سياسة الخصوصية (“السياسة”) كيفية جمع تطبيق مسارو (“نحن”، “خاصتنا”،
        أو “لنا”) واستخدام البيانات الشخصية للأفراد الذين يزورون التطبيق أو
        يتلقون الخدمات عبره. إن حماية بياناتك الشخصية أمر بالغ الأهمية بالنسبة
        لنا، ونحن نفهم مسؤوليتنا في التعامل مع بياناتك بعناية، وتأمينها،
        والامتثال للمتطلبات القانونية. نرجو منك قراءة هذه السياسة بعناية. فهي
        تقدم معلومات هامة حول كيفية استخدامنا للبيانات الشخصية وتوضح حقوقك
        القانونية. تنطبق هذه السياسة فقط على تطبيق مسارو ولا تمتد إلى مواقع
        الويب الخاصة بأي شركات أو منظمات أخرى، والتي قد نربط بها، والتي تدار من
        قبل أطراف ثالثة (بما في ذلك استخدامهم لملفات تعريف الارتباط). إذا كنت
        مستخدمًا لهذه الروابط، فإن مسؤوليتك هي فهم كيفية استخدام تلك الأطراف
        الثالثة لبياناتك، حيث لا نتحكم في المعلومات التي تُرسل أو تجمع بمجرد
        مغادرتك لتطبيقنا. نحن غير مسؤولين عن هذه المواقع الأخرى. عند زيارة
        التطبيق و/أو طلب الخدمات من خلاله، فإنك توافق، وعند الضرورة، تمنح
        الموافقة على جمع واستخدام ونقل معلوماتك كما هو موضح في هذه السياسة. لغرض
        حماية البيانات، سيكون تطبيق مسارو، المملوك من قبل مؤسسة الابتكار النجمي،
        المسجلة في الرياض، المملكة العربية السعودية، حي الورود، صندوق بريد
        12252، هو المتحكم في بياناتك الشخصية عند استخدام التطبيق.
      </p>

      <h2 className="section-title">
        ما المعلومات التي نجمعها منك وكيف نجمعها؟
      </h2>

      <p>سنقوم بجمع ومعالجة البيانات التالية عنك:</p>
      <ul>
        <li>
          عند التسجيل أو زيارة التطبيق أو الاتصال بنا من خلاله، قد يُطلب منك
          تقديم معلومات شخصية لإنشاء حساب، بما في ذلك اسمك، تفاصيل الاتصال،
          العنوان، رقم الهوية، اسم المستخدم وكلمة المرور، العنوان الكامل،
          ومعلومات الدفع مثل بيانات بطاقة الائتمان أو الخصم.
        </li>
        <li>
          قد نجمع معلومات حول استخدامك للتطبيق، والمعلومات التي تنشرها على
          التطبيق من رسائل أو مراجعات، والبيانات التي ترسلها لنا عبر WhatsApp.
        </li>
        <li>
          سجلات لأي مراسلات نجريها معك، بما في ذلك عند الاتصال بمقدمي الخدمة أو
          دعمنا عبر الهاتف أو WhatsApp، أو إذا اتصلت بنا هاتفيًا أو تواصلنا معك.
          قد نقوم أيضًا بمراقبة وتسجيل الاتصالات التي نجريها معك، بما في ذلك
          المكالمات الهاتفية والبريد الإلكتروني، لمساعدتنا في الحفاظ على مستويات
          الخدمة والامتثال لواجباتنا القانونية والتنظيمية.
        </li>
        <li>
          قد نجمع معلومات تقنية من جهازك المحمول أو استخدامك لخدماتنا عبر جهازك
          المحمول، مثل بيانات الموقع وبعض خصائص وأداء جهازك، نوع الاتصال ونظام
          التشغيل، عنوان IP، معرف الجهاز الفريد، وطرق الدفع عبر الهاتف المحمول،
          حيث يُسمح لنا بذلك لتنفيذ الطلبات التي قدمتها على التطبيق أو بموجب
          القانون. ما لم تختر البقاء مجهولًا عبر إعدادات جهازك أو النظام الأساسي
          الخاص بك، قد يتم جمع هذه المعلومات واستخدامها تلقائيًا عند استخدام أي
          من خدماتنا عبر جهازك المحمول.
        </li>
        <li>
          المعلومات التي تقدمها من خلال ملء النماذج على التطبيق، مثل نموذج “اتصل
          بنا”. يشمل ذلك المعلومات المقدمة عند الاشتراك في أي من خدماتنا أو
          القوائم البريدية مثل التقويم المالي، أو طلب خدمات إضافية. قد نطلب
          أيضًا معلومات اتصال عندما تبلغ عن مشكلة في التطبيق.{" "}
        </li>
        <li>
          تفاصيل زياراتك للتطبيق بما في ذلك، على سبيل المثال لا الحصر، بيانات
          المرور، بيانات الموقع، سجلات الويب، والموارد التي تصل إليها.
        </li>
        <li>
          قد نجمع معلومات حول جهازك، بما في ذلك عنوان IP ونظام التشغيل ونوع
          المتصفح، لأغراض إدارة النظام. هذه بيانات إحصائية حول سلوك وتصفح
          مستخدمينا ولا تحدد أي فرد.
        </li>
        <li>
          ردودك على أي استبيانات تسويقية، تقييمات مقدمي الخدمات أو أي خدمات
          أخرى، مسابقات أو عروض ترويجية قد نطلب منك إكمالها (رغم أنك لست مضطرًا
          للرد عليها). القُصّر لن نقوم عن قصد بجمع أي بيانات شخصية عن الأطفال أو
          الأشخاص الذين تقل أعمارهم عن 18 عامًا، ولا ننوي جمع البيانات الشخصية
          لزوار التطبيق الذين تقل أعمارهم عن 18 عامًا. ومع ذلك، لا يمكننا التحقق
          من عمر الأفراد عند زيارة التطبيق. لذلك، ننصح الآباء بمراقبة أنشطة
          أطفالهم على الإنترنت لمنع جمع بياناتهم الشخصية دون موافقة الوالدين.
          إذا شعرت أننا قد جمعنا بيانات شخصية لقاصر دون موافقة صالحة وبما يتماشى
          مع قوانين المملكة العربية السعودية (“KSA”)، يرجى الاتصال بنا عبر
          البريد الإلكتروني musaro.ksa@gmail.com وسنقوم بمحو هذه البيانات.
        </li>
      </ul>
      <h2 className="section-title">كيف نستخدم معلوماتك؟</h2>
      <p>في هذا القسم نوضح بتفصيل أكبر:</p>
      <ul>
        <li>الأغراض الرئيسية التي نستخدم فيها معلوماتك الشخصية </li>
        <li>الأسس القانونية التي نعتمد عليها لاستخدام معلوماتك الشخصية</li>
      </ul>
      <h2 className="section-title">الأغراض والأسس القانونية </h2>
      <p>لتسجيلك كعميل جديد وإدارة علاقتنا معك:</p>
      <ul>
        <li>
          جمع بيانات الهوية والاتصال لتسجيلك كعميل جديد في تطبيقنا لتلقي الخدمات
          والعروض.
        </li>
        <li>
          تزويدك بإمكانية الوصول إلى الأجزاء المناسبة من التطبيق وتوفير الخدمات
          التي طلبتها.
        </li>
        <li>الوفاء بالتزاماتنا بموجب أي عقود مبرمة بيننا وبينك.</li>
        <li> تمكيننا من إعداد فواتير دقيقة عند الدفع.</li>
        <li> إدارة الدفع والرسوم والتكاليف منك أو إليك.</li>
        <li> الرد على استفساراتك وطلباتك</li>
        <li> إبلاغك بالتغييرات على شروطنا وسياسة الخصوصية</li>
        <li>طلب تقييمك للخدمات أو مشاركتك في استبيان</li>
      </ul>
      <h2 className="section-title">الأساس القانوني</h2>
      <p>المصلحة المشروعة: نعتمد على المصالح المشروعة لتزويدك بالسلع والخدمات التي تطلبها ولتلبية وتسليم الطلبات.
	نعتمد على المصالح المشروعة للرد على استفساراتك والتأكد من قدرتنا على التواصل معك بشكل فعال لحل طلباتك،
 	وإبقائك على اطلاع بأي تغييرات، والاحتفاظ بهذه السجلات.

	الموافقة: عندما لا يمكننا الاعتماد على مصالحنا المشروعة لمعالجة معلوماتك الشخصية لأي من هذه الأغراض، سنقوم
	بذلك فقط بموافقتك.

</p>
<p><strong>ضمان جودة خدماتنا وفعالية تطبيقنا</strong><strong>:</strong></p>
<p><strong>&nbsp;</strong></p>
<ul>
<li>عندما نقوم بتسجيل مكالمات خدمة العملاء، فإننا نقوم بذلك لضمان الامتثال لشروط وأحكام خدمتنا، والحفاظ</li>
</ul>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; على معايير خدمة العملاء، ولأغراض التدريب وتحسين الخدمة لمساعدة موظفينا في التدريب.</p>
<ul>
<li>استخدام تحليلات البيانات لتحسين تطبيقنا، ومنتجاتنا، وخدماتنا، وتسويقنا، وعلاقات العملاء وتجاربهم.</li>
<li>طلب مشاركتك في الاستطلاعات، والملاحظات، وتقييم الخدمات أو مبادرات أخرى تساعد في جمع المعلومات</li>
</ul>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; التي تُستخدم لتطوير وتعزيز منتجاتنا وخدماتنا.</p>
<ul>
<li>تمكينك من المشاركة في الميزات التفاعلية لخدماتنا، إذا اخترت ذلك.</li>
<li>ضمان عرض المحتوى من تطبيقنا بطريقة أكثر فعالية لك ولجهاز الكمبيوتر والأجهزة المحمولة الخاصة بك.</li>
<li>إشعارك بالتغييرات التي تطرأ على خدماتنا.</li>
</ul>
<p>&nbsp;</p>
<p><strong>الأساس القانوني</strong></p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; المصالح المشروعة: لدينا مصلحة مشروعة في تزويدك بالمرافق على تطبيقنا التي طلبتها وفي فهم كيفية استخدام تطبيقنا</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; وشعبية المحتوى الموجود فيه. ومن الضروري لمصالحنا المشروعة أن نبقي تطبيقنا محدثًا وملائمًا لتطوير أعمالنا.</p>
<p>&nbsp;</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; الموافقة: عندما لا يمكننا الاعتماد على المصالح المشروعة لمعالجة معلوماتك الشخصية لأي من هذه الأغراض، سنقوم</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; بذلك فقط بموافقتك.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>التسويق والتسويق المباشر</strong><strong>:</strong></p>
<p><strong>&nbsp;</strong></p>
<ul>
<li>لتزويدك بمعلومات، عبر الهاتف، الرسائل القصيرة، واتساب، وكذلك البريد الإلكتروني، حول منتجاتنا أو خدماتنا</li>
</ul>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; التي تطلبها منا أو التي نشعر أنها قد تهمك، وذلك في حال وافقت على التواصل لأغراض كهذه.</p>
<ul>
<li>إذا اخترت على مستوى الجهاز البدء أو الاستمرار في تلقي الإشعارات الفورية منا، فقد نرسل لك إشعارات تتعلق</li>
</ul>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; بالخدمات التي طلبتها منا ومعلومات حول خدماتنا وعروضنا. يمكنك اختيار التوقف عن تلقي الإشعارات الفورية</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; منا في أي وقت من خلال تغيير تفضيلاتك على جهازك المحمول أو عبر التواصل معنا على <a href="mailto:musaro.ksa@gmail.com">musaro.ksa@gmail.com</a></p>
<ul>
<li>يرجى ملاحظة أنه إذا استخدمت خدمة &ldquo;اتصل بنا&rdquo; عبر الإنترنت أو أي أداة أخرى على تطبيقنا، فقد نتواصل معك</li>
</ul>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; من وقت لآخر بخصوص استفسارك الأولي.</p>
<ul>
<li>إذا كنت لا ترغب في استخدام بياناتك أو إذا غيرت رأيك بشأن التواصل معنا في المستقبل، يرجى إعلامنا عبر</li>
</ul>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; البريد الإلكتروني باستخدام تفاصيل الاتصال المذكورة أعلاه و/أو تعديل ملفك الشخصي وفقًا لذلك.</p>
<ul>
<li>قد نستخدم بياناتك الشخصية لإرسال اتصالات تسويقية مباشرة حول عروضنا، وترويجاتنا، وتجاربنا، أو خدماتنا</li>
</ul>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ذات الصلة. سيكون ذلك عبر البريد الإلكتروني، وسائل التواصل الاجتماعي، الرسائل القصيرة، أو الإعلانات</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; المستهدفة عبر الإنترنت، إذا كنت قد وافقت على ذلك.</p>
<p>&nbsp;</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; الأساس القانوني</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; المصلحة المشروعة: لدينا مصلحة مشروعة في فهم علاقتنا معك ومع العملاء المحتملين. نعتمد على المصلحة</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; المشروعة لدراسة كيفية استخدامك لمنتجاتنا وخدماتنا لتطويرها، وفهم اتجاهات السوق وخدمة العملاء لتنمية</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; أعمالنا وتوجيه استراتيجيتنا التسويقية.</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; الموافقة: عندما لا يمكننا الاعتماد على المصالح المشروعة لمعالجة معلوماتك الشخصية لأي من هذه الأغراض،</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; سنقوم بذلك فقط بموافقتك.</p>
<p><strong>الأغراض الداخلية للأعمال</strong><strong>:</strong></p>
<ul>
<li>لأغراض داخلية، مثل المراجعات الداخلية، إدارة التطبيق والنظام، التدقيقات الداخلية.</li>
<li>لإدارة وحماية أعمالنا وتطبيقنا، بما يشمل استكشاف الأخطاء وإصلاحها، تحليل البيانات، الاختبار، صيانة النظام،</li>
</ul>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; الدعم، التقارير واستضافة البيانات.</p>
<ul>
<li>لأغراض إجراء تحليلات البيانات، للتنبؤ بالاتجاهات المستقبلية في سلوك العملاء والاتجاهات الشرائية.</li>
</ul>
<p>&nbsp;</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; الأساس القانوني</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; المصلحة المشروعة: من الضروري لمصالحنا المشروعة ضمان توفير خدمات الإدارة؛ وأمان تكنولوجيا المعلومات</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; والشبكة للحماية من الاحتيال أو الجرائم الإلكترونية لتسيير أعمالنا.</p>
<p>&nbsp;</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; الالتزام القانوني: عندما لا نعتمد على المصلحة المشروعة، سنقوم بالمعالجة للامتثال بالتزام قانوني.</p>
<p>الامتثال لالتزاماتنا القانونية والتنظيمية</p>
<p>&nbsp;</p>
<ul>
<li>للمساعدةفيمنعواكتشافالاحتيالوالخسارة.</li>
<li>عندمايكونمنالضروريالامتثالللقوانينالأخرىالمعمولبهافيالمملكةالعربيةالسعودية.</li>
<li>لإدارة،ودعم،وتحسينوتطويرأعمالنا،ولأيغرضآخرسواءكانإحصائيًاأوتحليليًا،ولمساعدتنافيمنع</li>
</ul>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; الاحتيال.</p>
<ul>
<li>حسبالمتطلباتاللازمةللامتثاللالتزاماتناالقانونية،لحلالنزاعاتأوالامتثاللمتطلباتهيئةالبيانات</li>
</ul>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; والذكاء الاصطناعي السعودية (&ldquo;الجهة المختصة&rdquo;).</p>
<p>&nbsp;</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; الأساس القانوني: لجميع المعلومات &ndash; الامتثال لالتزام قانوني أو مصلحة مشروعة.</p>
<p>&nbsp;</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; كمؤسسة تجارية، لدينا مصلحة مشروعة في ضمان تنفيذ إجراءات إدارة المخاطر المناسبة في أعمالنا. لدينا</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; التزام قانوني كمؤسسة للإبلاغ والامتثال لأي قوانين والتزامات تنظيمية معمول بها.</p>
<p>على أي أساس قانوني يحق لنا معالجة بياناتك؟</p>
<p><strong>&nbsp;</strong></p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; كما هو موضح أعلاه، سنعالج معلوماتك وفقًا لنظام حماية البيانات الشخصية السعودي (&ldquo;PDPL&rdquo;) ولوائحه</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; التنفيذية (&ldquo;اللوائح&rdquo;) بناءً على أحد الأسس القانونية التالية:</p>
<ul>
<li>المادة 5 مننظام PDPL والمادة 11 مناللوائح - لقدمنحتناموافقةواضحةلمعالجةبياناتكالشخصية.</li>
<li>المادة 6 (2) مننظام PDPL - للامتثاللالتزامقانوني.</li>
<li>المادة 6 (4) - لمصالحناالمشروعةكمؤسسةتجارية،والتيتشمل -لكنلاتقتصرعلى- تقديمالخدمةلك،</li>
</ul>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; تنفيذ وتسليم الطلبات، تسويق منتجاتنا وخدماتنا، وإجراء تحليلات بيانات لمساعدتنا في التنبؤ بالاتجاهات</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; والسلوكيات المستقبلية للسوق.</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;مدة الاحتفاظ ببياناتك</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ما لم تتطلب القوانين السارية في المملكة العربية السعودية فترة احتفاظ أطول، سنحتفظ بمعلوماتك طالما كان</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; حسابك نشطًا، بالإضافة إلى فترة إضافية بعد ذلك لتغطية أي مسائل أو استفسارات قد تنشأ بخصوص</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; حسابك. سنقوم بمراجعة فترات الاحتفاظ بشكل دوري للتأكد من أنها مناسبة. لن نحتفظ ببياناتك لفترة أطول من</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; اللازم.</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; إذا كنت لا ترغب في التواصل معنا ولم تكن عميلًا نشطًا، يمكنك التواصل معنا عبر البريد الإلكتروني musaro.ksa@gmail.com وسنقوم بحذف معلوماتك فورًا.</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; إلى من نفصح عن معلوماتك؟</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; مزودي الخدمة لدينا</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; نفصح عن المعلومات لمزودي الخدمة الذين يقدمون خدمات نيابة عنا. خلال فترة حسابك، من المحتمل أن تتغير</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; هوية وفئات الأطراف الثالثة. سيتم استخدام بياناتك فقط من قبل مزودي الخدمة من الأطراف الثالثة لتقديم</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; الخدمات المطلوبة، وكل مزود خدمة يخضع لمجموعة من الشروط المتوافقة مع هذه السياسة. لدينا مصلحة مشروعة</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; في التواصل والتعامل مع مزودي الخدمة لتقديم الخدمات لنا وللعملاء.</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; نستخدم الأنواع التالية من مزودي الخدمة الخارجيين لتقديم خدمات لنا:</p>
<ul>
<li>مقدموخدماتإدارةواستضافةالتطبيقات</li>
<li>مقدموقواعدالبيانات،إدارةالمبيعاتوبرامجتفاعلالسوق</li>
<li>مقدموحلولالدفع</li>
<li>وكالاتمكافحةالاحتياللمساعدتنافياتخاذقراراتحولقدرتكعلىالدفع،التحققمنالهوية،منع</li>
</ul>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; الاحتيال وغسل الأموال وإدارة الحساب</p>
<ul>
<li>مقدموخدماتاستطلاعاتالرأيوبحوثالسوق</li>
<li>مقدموأدواتالتواصلبالبريدالإلكترونيومنصاتالندواتعبرالإنترنت</li>
<li>المتاجرالشريكةأومقدموالخدمةالذينقمتبتقديمطلبلديهم</li>
<li>مقدموخدماتالطباعةالخارجية</li>
<li>مدققونخارجيون،عندالضرورةللامتثاللالتزاماتناالقانونيةوالتنظيمية.</li>
</ul>
<p>&nbsp;</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; أطراف أخرى</p>
<p>&nbsp;</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; قد نفصح عن معلوماتك الشخصية لأي عضو في فريقنا.</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; قد نفصح أيضًا عن معلوماتك الشخصية لأطراف أخرى:</p>
<ul>
<li>فيحالبيعأوشراءأينشاطتجاريأوأصول،وفيهذهالحالةقدنفصحعنبياناتكالشخصيةللبائع</li>
</ul>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; أو المشتري المحتمل لذلك النشاط التجاري أو الأصول.</p>
<ul>
<li>إذاطلبتأووافقتعلىالإفصاحعنمعلوماتكلطرفثالث.</li>
<li>إذاتمالاستحواذعلى Musaro أومالكهاالأصلي،مؤسسة Innovation Star،أوعلىمعظمأصولها</li>
</ul>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; من قبل طرف ثالث، ستكون بيانات العملاء من بين الأصول المنقولة.</p>
<ul>
<li>إذاكناملزمينبالكشفأومشاركةبياناتكالشخصيةللامتثاللأيالتزامقانونيأوتنظيمي.</li>
</ul>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; مكان تخزين معلوماتك ونقل بياناتك خارج المملكة العربية السعودية</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; نظرًا لأن مقرنا في المملكة العربية السعودية، فإن المعلومات التي نجمعها منك سيتم نقلها وتخزينها ومعالجتها</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; داخل المملكة العربية السعودية. ومع ذلك، فإن قلة من مزودي الخدمة لدينا يقعون خارج المملكة. وقد يتغير هذا إذا</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; قررنا البدء في استخدام مزودي خدمة مختلفين.</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; وبالتالي، قد يتم نقل البيانات التي نجمعها منك إلى وجهة خارج المملكة وتخزينها ومعالجتها هناك. سنقوم دائمًا</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; باتخاذ الخطوات اللازمة لضمان أن أي نقل دولي للبيانات الشخصية يتم إدارته بعناية لحماية حقوقك ومصالحك،</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; وخاصةً من خلال:</p>
<ul>
<li>نقلبياناتكالشخصيةفقطإلىالدولالتييتمالاعترافبهاكدولتوفرمستوىمناسبًامنالحماية</li>
</ul>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; القانونية ومعتمدة من قبل السلطة المختصة.</p>
<ul>
<li>التأكدمنأنعملياتالنقلخارجالمملكةالعربيةالسعوديةتخضعلضماناتقانونيةمناسبةمثلالشروط</li>
</ul>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; التعاقدية القياسية والقواعد الملزمة المشتركة.</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; حقوقك</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; يحق لك أن تطلب منا عدم معالجة بياناتك الشخصية لأغراض التسويق.</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; يمكنك ممارسة هذا الحق في أي وقت لمنع هذه المعالجة من خلال الاتصال بنا عبر البريد الإلكتروني musaro.ksa@gmail.com.</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; يحق لك أن تطلب منا معلومات إضافية حول الضمانات التي قمنا بوضعها فيما يتعلق بنقل البيانات.</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; لن نقوم بمعالجة أي بيانات شخصية حساسة دون الحصول على موافقتك الصريحة وفقًا لنظام حماية البيانات</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; الشخصية PDPL واللوائح في المملكة العربية السعودية.</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; كصاحب بيانات، لديك الحقوق التالية:</p>
<ul>
<li>الحقفيأنيتمإبلاغكباستخدامبياناتكالشخصية.</li>
<li>الحقفيالوصولإلىبياناتكالشخصية.</li>
<li>الحقفيطلبتصحيحبياناتكالشخصيةبمافيذلكأيبياناتتحتاجإلىتحديث.</li>
<li>الحقفيطلبإتلافأوحذفبياناتكالشخصية.</li>
<li>الحقفيطلبالحصولعلىبياناتكالشخصيةفيصيغةواضحةوقابلةللقراءة.</li>
<li>الحقفيسحبالموافقةفيأيوقت.</li>
</ul>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; التغييرات على سياسة الخصوصية الخاصة بنا</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; سنجري تغييرات على هذه السياسة من وقت لآخر، على سبيل المثال، للحفاظ على تحديثها أو للامتثال للمتطلبات</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; القانونية أو التغييرات في كيفية تشغيل أعمالنا. سنحرص على أن تكون على علم بأي تغييرات هامة عن طريق</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; إرسال رسالة SMS إلى رقم الهاتف الذي قدمته لنا مؤخرًا أو عن طريق نشر إشعار على التطبيق، لتكون على</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; علم بتأثير التغييرات على أنشطة معالجة البيانات قبل المتابعة في المشاركة. نشجعك على التحقق بانتظام من هذه</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; السياسة ومراجعتها لتبقى على علم دائمًا بالمعلومات التي نجمعها وكيف نستخدمها ومع من نشاركها.</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; الاتصال</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; إذا كان لديك أي شكاوى أو قضايا بخصوص هذه السياسة، بما في ذلك حقوق ممارسة طلبات صاحب البيانات،</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; يرجى الاتصال بنا عبر البريد الإلكتروني musaro.ksa@gmail.com.</p>
    </div>
  );
};

export default PrivacyPolicyAppArabic;
